import { render, staticRenderFns } from "./CommentLikeButton.vue?vue&type=template&id=7172f52a&scoped=true&"
import script from "./CommentLikeButton.vue?vue&type=script&lang=js&"
export * from "./CommentLikeButton.vue?vue&type=script&lang=js&"
import style0 from "./CommentLikeButton.vue?vue&type=style&index=0&id=7172f52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7172f52a",
  null
  
)

export default component.exports